<!-- OrderDetailBody.vue -->
<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="订单详情" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div
                class="order-body"
                v-if="order_info"
        >
            <div class="order_state">
                <i class="iconfont" v-if="order_info.order_state == '40'">&#xe61b;</i>
                <i class="iconfont" v-else>&#xe61a;</i>
                <span>{{order_info.order_state_text}}</span>
            </div>

            <div class="address">
                <div>
                    <span class="mobile" v-if="order_info.virtual_type==0">接收手机：{{ order_info.buyer_phone }}</span>
                    <div style="font-size:.7rem;display:flex;padding:0" class="mobile" v-if="order_info.virtual_type==1">
                    <div style="padding:0" class="left">卡券：</div>
                    <div style="padding:0;flex:1;" class="right">
                    <div style="padding:0" v-for="(item ,index) in order_info.virtual_content" :key="index">
                    {{ item }}
                    </div>
                    </div>
                    </div>
                    <span class="mobile" v-if="order_info.virtual_type==2">网盘：{{ order_info.virtual_content }}</span>
                    <span class="mobile" v-if="order_info.virtual_type==3">下载：<a :href="order_info.vc_file_url" target="_blank">下载资源</a></span>
                </div>
                <div v-if="order_info.virtual_type==0 && order_info.code_list && order_info.code_list.length" class="vr_code">
                    <span v-for="(item ,index) in order_info.code_list" :key="index">
                        <span>兑换码{{item.vr_code}}<i @click="showQrcode(item.vr_code)" v-if="item.vr_state==0 && item.vr_indate>$moment().unix() && item.refund_lock==0" class="qrcode iconfont">&#xe64a;</i></span><br><span class="state">{{item.vr_code_desc}}</span>
                    </span>
                </div>
            </div>

            <div class="order_store" @click="$router.push({name:'HomeStoredetail', 'query': { 'id': order_info.store_id }})">
                <i class="store iconfont">&#xe62d;</i><span>{{order_info.store_name}}</span><i class="more iconfont">&#xe650;</i>
            </div>
            <div
                    class="containers"
            >

                <img
                        class="photo"
                        v-bind:src="order_info.goods_image_url"
                />
                <div class="right-wrapper">
                    <label class="title">{{ order_info.goods_name }}</label>
                    <label class="property">{{ order_info.goods_spec }}</label>
                    <div class="desc-wrapper">
                        <div>
                            <label class="price"
                            >$ {{ order_info.goods_price }}</label
                            >
                            <label class="count">x{{ order_info.goods_num }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="detail">
                <div class="number">
                    <label
                    >订单编号：{{ order_info.order_sn }}
                    </label>
                    <p>
                        下单时间：{{order_info.add_time}}
                    </p>
                </div>
                <div class="div number">
                    <p v-if="order_info.voucher_code">
                        使用了面额为 {{order_info.voucher_price}} 元的店铺代金券
                    </p>
                    <p v-if="order_info.mallvoucher_price">
                        使用了面额为 {{order_info.mallvoucher_price}} 元的平台代金券
                    </p>
                </div>
                <div class="pay" v-if="order_info.payment_name">
                    <p>支付方式：{{ order_info.payment_name }}</p>
                </div>

            </div>

            <div
                    class="desc section-header section-footer"
            >

                <div class="container" v-if="order_info.promotion && order_info.promotion.length > 0">
                    <label class="title">优惠</label>
                    <label class="subtitle" v-for="(p,i) in order_info.promotion" v-bind:key="i">{{p[1]}}}</label>
                </div>
                <label class="amount"
                >实付款 : <span> ${{ order_info.order_amount }}</span>
                </label>
            </div>

        </div>

        <mt-popup v-model="popupRefund" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="售后" class="common-header">
                    <mt-button slot="left" icon="back" @click="popupRefund=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div @click='refund(1)'><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">退款</span></flex-line></div>
                <div @click='refund(2)'><flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">退货</span></flex-line></div>
            </div>
        </mt-popup>
    </div>
</template>

<script>

import { Toast, MessageBox } from 'mint-ui'
import { getOrderInfo } from '../../../api/memberVrOrder'
import flexLine from '../../flexLine'
export default {
  name: 'MemberOrderDetail',
  data () {
    return {
      order_info: {},
      rec_id: 0,
      popupRefund: false
    }
  },
  components:{
    flexLine
  },

  created: function () {
    if (this.$route.query.order_id) {
      getOrderInfo(this.$route.query.order_id).then(res => {
        this.order_info = res.result.order_info
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },

  methods: {
    showQrcode (vr_code) {
      MessageBox({
        title: '兑换码' + vr_code,
        message: '<div class="common-alert-content"><img src="' + env.API_HOST + '/index/getQrcode?url=' + encodeURIComponent(env.H5_HOST + '/seller/vrorder_list?vr_code=' + vr_code) + '"><div class="alert-notice">请让卖家扫码或者输入兑换码进行核销</div></div>',
        confirmButtonText: '关闭'
      })
    },
    showRefund (rec_id) {
      this.rec_id = rec_id
      this.popupRefund = true
    },
    refund (type) {
      this.$router.push({ name: 'MemberReturnForm', query: { type: type, order_id: this.order_info.order_id, order_goods_id: this.rec_id } })
    },

    complaint (order_id, goods_id) {
      this.$router.push({ name: 'MemberComplaintForm', query: { order_id: order_id, goods_id: goods_id } })
    }
  }
}
</script>
<style lang="scss" scoped>
    .common-header-wrap .common-header{box-shadow: unset}
    .order-body {
        overflow: auto;
        height: 100%;
        position: absolute;
        width: 100%;
        .desc{
            .container {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background-color: #fff;
            }
            .title {
                width:5rem;
                font-size:$subFontSize;
                color: #333;
                margin-left:0.6rem;
            }
            .subtitle {
                flex: 1;
                margin-left:1rem;
                margin-right:0.6rem;
                color: $primaryColor;
                font-size:$subFontSize;
                text-align: right;
            }
        }

    }
    .order_state {
        background:$primaryColor;
        height:3.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        i {
            color:#fff;
            font-size:1.2rem;
            padding: 0 0.5rem;
        }
        span {
            font-size:$h2;
            color: #fff;
        }
    }
    .containers {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }
    .photo {
        width:4rem;
        height:4rem;
        margin:0.75rem 0.5rem 0.75rem 0.75rem;
        border: 1px solid #e8eaed;
        flex-basis:4rem;
        flex-shrink: 0;
    }
    .right-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 0 0.75rem 0 0;
        width: 100%;
        overflow: hidden;
    }
    .title {
        margin-top:0.75rem;
        color: #333;
        font-size:$subFontSize;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .property {
        font-size:$subFontSize;
        color: #7c7f88;
        padding-top:0.5rem;
    }
    .count {
        margin-top:0.2rem;
        color: #7c7f88;
        font-size:$subFontSize;
        margin-right:0.5rem;
    }
    .desc-wrapper {
        height:1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top:1rem;
    }
    .price {
        color: $primaryColor;
        font-size:$h2;
        margin-left: 0;
    }
    .count {
        color: #7c7f88;
        font-size:$h2;
        margin-left:0.5rem;
    }
    .address {
        padding-bottom:0.5rem;
        background-color: #fff;
        margin-bottom:0.5rem;
        div {
            padding:0.5rem 0.5rem 0;
        }
        img {
            height:0.8rem;
        }
        span {
            color: #333;
            font-size:$subFontSize;
            .iconfont {float:right;font-size:$h2;line-height:1.5}
        }
        p {
            margin:0.6rem 0.9rem 0.5rem 0.5rem;
            font-size:$subFontSize;
            color: #7c7f88;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .contact {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height:2.3rem;
        background-color: #fff;
        margin-top:0.4rem;
        border-bottom: 1px solid #e8eaed;
        padding: 0 0.65rem;
        span {
            font-size:$fontSize;
            color: #333;
            padding-right:0.3rem;
        }
        img {
            width:0.6rem;
            height:0.65rem;
        }
    }

    .detail {
        display: flex;
        flex-direction: column;
        font-size:$subFontSize;
        color: #7c7f88;
        background-color: #fff;
        margin:0.4rem 0;
        box-sizing: border-box;
        .number {
            padding:0.7rem 0.8rem;
            border-bottom: 1px solid #e8eaed;
            p {
                padding-top:0.3rem;
                font-size:$subFontSize;
            }
            button {
                color: #7c7f88;
                height:1rem;
                background-color: #fff;
                border: 1px solid #7c7f88;
                width:2.7rem;
                height:1rem;
                border-radius:0.1rem;
                font-size:$subFontSize;
            }
        }
        .pay {
            border-bottom: 1px solid #e8eaed;
            padding:0.7rem 0.8rem;
        }
        .givetime {
            padding:0.7rem 0.8rem;
            font-size:$subFontSize;
        }
        input {
            background-color: #fff;
            border: 1px solid #7c7f88;
        }
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        box-sizing: border-box;
        margin-bottom:4rem;
        .desc-item {
            flex: 1;
            margin-top:0.5rem;
        }
        .amount {
            display: flex;
            justify-content: flex-end;
            font-size:$subFontSize;
            color: #333;
            padding-right:0.8rem;
            border-top: 1px solid #e8eaed;
            height:2.2rem;
            line-height:2.2rem;
            span {
                font-size:$h2;
                color: $primaryColor;
            }
        }
    }
    .ship { margin-bottom: 0;}
    .vr_code > span{border-top:1px solid #e1e1e1;display: block;padding-top:0.5rem;padding-bottom:0.5rem}
    .vr_code > span:last-child{padding-bottom:0}
    .vr_code .state{font-size:$subFontSize;color:#7c7f88}

    .order_store{background:#fff;height:1rem;line-height:1rem;padding:0.5rem 0.8rem;border-bottom:1px solid #f5f5f5}
    .order_store span{color:#333;font-size:$subFontSize;font-weight:600;float:left;margin:0 0.4rem;}
    .order_store i.store{float:left}
    .order_store i.more{float:left;font-size:$subFontSize;}
</style>

<!-- 字体图标样式覆盖 -->
<style lang="scss">
    .mint-toast-icon {
        font-size: 1.9rem;
    }
    button {
        padding: 0;
    }
</style>
